import React, {Component} from 'react';
import {connect} from 'react-redux';
import {API_URL} from "../../config/Config";
import validator from "validator";
import axios from "axios/index";
import {LangValidation} from "../../lang/en/validation";
import {Row, Col, Alert, Button} from "reactstrap";
import PageLoader from "../loader/PageLoader";
import SaveLoader from "../../components/loader/SaveLoader";
import SweetAlert from 'sweetalert2-react';
import axiosRetry from 'axios-retry';
axiosRetry(axios, { retries: 3 });

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            activeItemPills: '1',
            fields: {
              old_password:"",
              password:"",
              re_password:"",
            },
            errors: {},
            hasAlert:false,
            loading1:true,
            isSave:false,
            type:'success',
            title:'Your information save successful.'
        };

    }

    handleValidation(callback) {
        let {fields} = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.old_password)) {
            formIsValid = false;
            errors["old_password"] = LangValidation.required;
        }else if (!validator.isLength(fields.old_password, {min: 6, max: undefined})) {
            formIsValid = false;
            errors["old_password"] = LangValidation.min;
        }

        if (validator.isEmpty(fields.password)) {
            formIsValid = false;
            errors["password"] = LangValidation.required;
        }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
            formIsValid = false;
            errors["password"] = LangValidation.min;
        }

        if (validator.isEmpty(fields.re_password)) {
            formIsValid = false;
            errors["re_password"] = LangValidation.required;
        }else if (fields.re_password !== fields.password) {
            formIsValid = false;
            errors["re_password"] = LangValidation.same;
        }

        this.setState({errors}, () => {
            return callback(formIsValid)
        });

    }

    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

        switch (target.name) {
            case 'old_password':
                if (validator.isEmpty(fields.old_password)) {
                    errors["old_password"] = LangValidation.required;
                }else if (!validator.isLength(fields.old_password, {min: 6, max: undefined})) {
                    errors["old_password"] = LangValidation.min;
                }
                break;
            case 'password':
                if (validator.isEmpty(fields.password)) {
                    errors["password"] = LangValidation.required;
                }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
                    errors["password"] = LangValidation.min;
                }
                break;
            case 're_password':
                if (validator.isEmpty(fields.re_password)) {
                    errors["re_password"] = LangValidation.required;
                }else if (fields.re_password !== fields.password) {
                    errors["re_password"] = LangValidation.same;
                }
                break;
            default:
        }
        this.setState({
            fields,errors
        });

    }

    async handleRequest() {
        const {old_password, password} = this.state.fields;
        const formData = {old_password, new_password: password};
        this.setState({loading1:false,hasAlert:false});

        try {
            let response = await axios.post(`${API_URL}user-changepassword?api_token=${this.props.user.apiToken}`, formData);
            let message = await response.data.data;
            let status = await response.data.status;

            if(status === "success"){
                this.setState({
                    isSave:true,
                    type:'success',
                    title:'Your information save successful.'
                });
            }else{
                this.setState({
                    isSave:true,
                    type:'error',
                    title:message.toString()
                });
            }
        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
                this.setState({
                    isSave:true,
                    type:'error',
                    title: "An occurred during saving your info, try again."
                });
            } else {
                let data = await apiError.data;
                let apiErrorText = await data.data;
                this.setState({apiErrorText});
                this.setState({
                    isSave:true,
                    type:'error',
                    title: apiErrorText.toString()
                });
            }
        }
        this.setState({hasAlert:true, loading1:true});
    };

    handleSubmit(event) {
        event.preventDefault();
        this.handleValidation((valid) => {
            if (valid) this.handleRequest();
        });
    }

    render() {
        const {old_password, password, re_password} = this.state.fields;
        const {errors, loading} = this.state;


        return (
            <div className="pt-3">
                <Row>
                    <Col md="12">
                        {this.state.hasAlert?
                            <Alert color="danger">
                                An occurred during saving your info, try again.
                            </Alert>
                            :""}
                    </Col>
                </Row>
                {!loading ? <PageLoader type="bubbles" color="#4fbfa8"/>:
                    <form>
                        <Row>
                            <Col md="3" sm="12"/>
                            <Col md="6" sm="12">
                                <div className="md-form input-group" error="true" >
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                    </span>
                                    <input
                                        type="password"
                                        className={errors["old_password"]?"form-control is-invalid":"form-control"}
                                        placeholder="Current Password"
                                        autoComplete="off"
                                        name="old_password"
                                        value={old_password}
                                        onChange={this.handleChange.bind(this)}
                                    />
                                    {errors["old_password"]?<div className="invalid-feedback" >{errors["old_password"]}</div>:""}
                                </div>
                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                    </span>
                                    <input type="password"
                                           placeholder="New Password"
                                           className={errors["password"]?"form-control is-invalid":"form-control"}
                                           autoComplete="off"
                                           name="password"
                                           value={password}
                                           onChange={this.handleChange.bind(this)}
                                    />
                                    {errors["password"]?<div className="invalid-feedback" >{errors["password"]}</div>:""}
                                </div>
                                <div className="md-form input-group">
                                    <span className="input-group-addon p-2">
                                        <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                    </span>
                                    <input type="password"
                                           placeholder="New Password Verify"
                                           className={errors["re_password"]?"form-control is-invalid":"form-control"}
                                           autoComplete="off"
                                           name="re_password"
                                           value={re_password}
                                           onChange={this.handleChange.bind(this)}/>
                                    {errors["re_password"]?<div className="invalid-feedback" >{errors["re_password"]}</div>:""}

                                </div>
                                <div className="text-center mt-5">
                                    <Button color="info" block onClick={this.handleSubmit.bind(this)} className="mb-4 mt-4">
                                        ثبت<i className="fa fa-paper-plane-o white-text ml-1"></i>
                                    </Button>
                                </div>



                            </Col>


                        </Row>
                    </form>}

                {!this.state.loading1 ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight}/>:""}
                <SweetAlert
                    show={this.state.isSave}
                    title={this.state.title}
                    type={this.state.type}
                    showConfirmButton={true}
                    onConfirm={() => this.setState({ isSave: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};

export default connect(mapStateToProps, null)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/user/ChangePassword.js